(() => {
'use strict';
document.querySelectorAll('[data-product-section]').forEach(section => {
  const source = section.querySelector('[data-biomevia-variants]');
  if (!source) return;
  const variants = JSON.parse(source.textContent);
  const select = section.querySelector('select[name="id"]');
  const update = () => {
    const id = section.querySelector('[name="id"]')?.value;
    const variant = variants.find(v => String(v.id) === String(id));
    if (!variant) return;
    section.querySelectorAll('[data-product-price], .medixo-mobile-order-bar strong').forEach(node => node.textContent = variant.price);
    const sku = section.querySelector('[data-variant-sku]');
    if (sku) { sku.textContent = variant.sku ? 'Référence : ' + variant.sku : ''; sku.hidden = !variant.sku; }
    const stock = section.querySelector('[data-variant-stock]');
    if (stock) { stock.textContent = variant.stock; stock.classList.toggle('is-unavailable', !variant.available); }
    section.querySelectorAll('[data-medixo-add] button[type="submit"], [data-mobile-add-target]').forEach(button => button.disabled = !variant.available);
  };
  select?.addEventListener('change', update);
  update();
});
})();